/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FunctionComponent } from 'react';
import { RiOrganizationChart } from 'react-icons/ri';
import { useHistory } from 'react-router-dom';
import { IDefaultChartCategoryProps } from './types';

export const DEFAULT_CHART_CATEGORY_TITLE = 'Organizational Chart';
export const DEFAULT_CHART_ITEM_TITLE = 'Main chart';
export const DEFAULT_CHART_PATH = '/chart';

const DEFAULT_COLOR = '#1BC3A7';
const DEFAULT_ITEMS = [{ title: DEFAULT_CHART_ITEM_TITLE, url: DEFAULT_CHART_PATH }] as const;

export const DefaultChartCategory: FunctionComponent<IDefaultChartCategoryProps> = ({
  title = DEFAULT_CHART_CATEGORY_TITLE,
  avatar = null,
  color = DEFAULT_COLOR,
}) => {
  const history = useHistory();

  return (
    <div className="panel agency-tools-item">
      <div className="agency-item-top-part">
        {avatar ? (
          <div className="agency-icon">
            <img src={avatar} alt="" className="round-icon" style={{ marginRight: 0 }} />
          </div>
        ) : (
          <div className="agency-icon">
            <span className="round-icon" style={{ backgroundColor: color, marginRight: 0 }}>
              <RiOrganizationChart size={24} color="#fff" />
            </span>
          </div>
        )}
        <h2 className="bold mt-2">{title}</h2>
      </div>
      <div className="agency-item-bottom-part pt-0 pb-3 px-5">
        <div className="list w100 overflow-hidden d-block showAllContainer">
          {DEFAULT_ITEMS.map((item) => (
            <div className="list-item h35 mb-0 aic jcc border-bottom" key={item.url}>
              <a className="link flex aic" style={{ color }} onClick={() => history.push(item.url)}>
                {item.title}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
